// Valores por defecto (desarrollo). En servidores NO edites este archivo:
// usa planillas-frontend/.env.production (ver .env.production.example).
// En deploy: git pull debe ganar siempre sobre cambios locales aquí.

// Variables de entorno por defecto para desarrollo
const DEFAULT_CONFIG = {
  API_BASE_URL: 'https://rpu-planillas.contifine-systems.online/api',
  API_TIMEOUT: 30000000000, // 30 segundos es más razonable
  SANCTUM_TOKEN_KEY: 'planillas_sanctum_token',
  USER_KEY: 'planillas_user',
  COMPANY_KEY: 'planillas_company',
  COMPANY_SESSION_KEY: 'planillas_company_session',
  JATSA_FRONTEND_URL: 'http://localhost:5173'
};

// Función para obtener configuración desde variables de entorno de React o usar defaults
export const getEnvironmentConfig = () => {
  return {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || DEFAULT_CONFIG.API_BASE_URL,
    API_TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT) || DEFAULT_CONFIG.API_TIMEOUT,
    SANCTUM_TOKEN_KEY: process.env.REACT_APP_SANCTUM_TOKEN_KEY || DEFAULT_CONFIG.SANCTUM_TOKEN_KEY,
    USER_KEY: process.env.REACT_APP_USER_KEY || DEFAULT_CONFIG.USER_KEY,
    COMPANY_KEY: process.env.REACT_APP_COMPANY_KEY || DEFAULT_CONFIG.COMPANY_KEY,
    COMPANY_SESSION_KEY: process.env.REACT_APP_COMPANY_SESSION_KEY || DEFAULT_CONFIG.COMPANY_SESSION_KEY,
    JATSA_FRONTEND_URL: process.env.REACT_APP_JATSA_FRONTEND_URL || DEFAULT_CONFIG.JATSA_FRONTEND_URL
  };
};

// Exportar configuración actual
export const ENV_CONFIG = getEnvironmentConfig();

// Debug: mostrar configuración en desarrollo
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Configuración de entorno:', ENV_CONFIG);
} 
